import React from "react";

/**
 * Catches any uncaught React error and shows a friendly branded fallback so the
 * site remains usable on older browsers or in the rare case of a runtime error.
 * Includes the phone number so users can always call/text to book.
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // Best-effort — do not throw from here
    try {
      // eslint-disable-next-line no-console
      console.error("Rockstar site error boundary caught:", error, info);
    } catch (_) {
      /* noop */
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            minHeight: "100vh",
            background: "#0a0a0a",
            color: "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "24px",
            fontFamily: "'Manrope','Helvetica Neue',Arial,sans-serif",
            textAlign: "center",
          }}
        >
          <div style={{ maxWidth: 520 }}>
            <p
              style={{
                fontSize: 10,
                letterSpacing: "0.28em",
                color: "#E63946",
                textTransform: "uppercase",
                fontFamily: "'JetBrains Mono',monospace",
                marginBottom: 12,
              }}
            >
              Rockstar ATV Rentals
            </p>
            <h1
              style={{
                fontFamily: "'Oswald','Impact',sans-serif",
                fontSize: 42,
                lineHeight: 0.95,
                textTransform: "uppercase",
                margin: 0,
              }}
            >
              We&rsquo;re <span style={{ color: "#E63946" }}>ready to ride.</span>
            </h1>
            <p style={{ marginTop: 16, color: "rgba(255,255,255,0.7)", fontSize: 14, lineHeight: 1.6 }}>
              The full site didn&rsquo;t load on your browser. Text or call us and we&rsquo;ll
              book your Honda Talon or Rancher ride in Kissimmee, Ocala, or Orlando FL.
            </p>
            <div style={{ marginTop: 24, display: "flex", flexDirection: "column", gap: 10 }}>
              <a
                href="sms:4079153661"
                style={{
                  background: "#E63946",
                  color: "#fff",
                  padding: "14px 18px",
                  textDecoration: "none",
                  fontWeight: 700,
                  fontSize: 12,
                  letterSpacing: "0.18em",
                  textTransform: "uppercase",
                }}
              >
                Text (407) 915-3661
              </a>
              <a
                href="tel:4079153661"
                style={{
                  border: "1px solid rgba(255,255,255,0.35)",
                  color: "#fff",
                  padding: "13px 18px",
                  textDecoration: "none",
                  fontWeight: 700,
                  fontSize: 12,
                  letterSpacing: "0.18em",
                  textTransform: "uppercase",
                }}
              >
                Call (407) 915-3661
              </a>
              <a
                href="mailto:Rockstaratvrentals@gmail.com"
                style={{
                  color: "rgba(255,255,255,0.8)",
                  fontSize: 12,
                  marginTop: 6,
                  textDecoration: "none",
                }}
              >
                Rockstaratvrentals@gmail.com
              </a>
              <button
                onClick={() => window.location.reload()}
                style={{
                  marginTop: 12,
                  background: "transparent",
                  border: "none",
                  color: "rgba(255,255,255,0.5)",
                  textDecoration: "underline",
                  cursor: "pointer",
                  fontSize: 12,
                }}
              >
                Reload the site
              </button>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
